<div class="login-container">
  <div class="login-card">
    <app-header 
        heading="Forgot Password" 
        subheading="Enter your login email to reset password"></app-header>

    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
      <div class="form-group" style="margin-top: 1rem;">
        <!-- <label for="email">Enter your email</label> -->
        <input id="email" type="email" formControlName="email" placeholder="Enter your email" />
      </div>

      <div class="form-footer">
        <button type="submit" class="sign-in-btn" [disabled]="forgotPasswordForm.invalid || isLoading">
          {{ isLoading ? 'Sending...' : 'Send Reset Link' }}
        </button>
      </div>

      <p *ngIf="message" class="error-message">{{ message }}</p>
    </form>

    <p class="create-account">
      <a href="/login">Back to login</a>
    </p>
  </div>
</div>
